import { QuestionTypeIds } from "@core/enums";

export class CtConstants {
  static readonly ctQuestionTypeIds = [QuestionTypeIds.CHOOSE_TEN, QuestionTypeIds.PICTURE_ROUND, QuestionTypeIds.PUZ_MATCHING, QuestionTypeIds.TWO_COLUMN];
}
